import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';

export default class setProgressMeasureMutation {
  constructor(props) {
    this.props = props;
  }

  setProgressMeasurePayload = Relay.QL`
    fragment on SetProgressMeasureForLearningCardPayload {
      cardPerformance {
        scaledProgressMeasure
        timeSpent
        lastUpdatedTimeSpent
        lastUpdatedComplete
        progressMeasure
        successStatus
        lastUpdated
        completionStatus
        rawScore
        scaledProgressMeasure
      }
      coursePerformance {
        timeSpent
        lastUpdatedTimeSpent
        lastUpdated
        scaledProgressMeasure
        completionStatus
        lastUpdatedComplete
      }
    }
  `;

  commit(callbacks) {
    const query = Relay.QL`
      mutation setProgressMeasureForLearningCardMutation($input: SetProgressMeasureForLearningCardInput!) {
        setProgressMeasureForLearningCard(input: $input) {
          ${this.setProgressMeasurePayload}
          clientMutationId
        }
      }
    `;

    const variables = {
      userId: this.props.userId,
      input: {
        rootOfferId: this.props.courseId,
        cardId: this.props.cardId,
        progressMeasure: this.props.progressMeasure,
        userId: this.props.userId,
        timeStamp: new Date().toISOString()
      }
    };

    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = [{ type: 'FIELDS_CHANGE' }];
    config[0].fieldIDs = {
      cardPerformance: this.props.mainId,
      coursePerformance: this.props.coursePerformanceId,
      curriculum: this.props.pathGraphId
    };

    mutation.commit(config);
  }
}
